export const WIDTH = '75%';
